(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookMergeHeaderDetailController', HandbookMergeHeaderDetailController);

    HandbookMergeHeaderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HandbookMergeHeader', 'Handbook', 'HandbookVersion', 'CustomUser'];

    function HandbookMergeHeaderDetailController($scope, $rootScope, $stateParams, previousState, entity, HandbookMergeHeader, Handbook, HandbookVersion, CustomUser) {
        var vm = this;

        vm.handbookMergeHeader = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('teJHipsterApp:handbookMergeHeaderUpdate', function(event, result) {
            vm.handbookMergeHeader = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
